import Api from './Api'
import { Booking, BookingFilterProperty } from '../types'
import SearchHelper from '../helpers/SearchHelper'

export interface BookingsResponse {
  bookings: Booking[]
  current_page: number
  total_pages: number
  per_page: number
  total_entries: number
}

export default class BookingsController extends Api {
  static getBookings(params: { page: number, per_page: number, search?: string, order?: string } & { [key in BookingFilterProperty]?: any }): Promise<BookingsResponse> {
    return fetch(`/api/bookings?${SearchHelper.getQueryString(params)}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: this.token,
      },
      credentials: 'same-origin',
    }).then(res => res.json())
  }
}
